// extracted by css-extract-rspack-plugin
export default {"actionConfigEdge__button":"actionConfigEdge__button-IBsxM4","actionConfigEdgeButton":"actionConfigEdge__button-IBsxM4"};